"use client";

import { useEffect, useState } from "react";
import styled from "styled-components";
import { Col } from "react-bootstrap";
import Title from "@/components/Title";
import { White } from "@/styles/globalStyleVars";
import { IconText } from "@/components/common/icon-text";

const MyComponent = ({ data, sectionID }) => {
  const [offset, setOffset] = useState(90);
  useEffect(() => {
    setOffset(document.querySelector(".container").offsetLeft + 15);
    window.addEventListener("resize", () => {
      setOffset(document.querySelector(".container").offsetLeft + 15);
    });
  }, []);

  return (
    <StyledComponent
      id={`${sectionID ? sectionID : ""}`}
      className={"capability"}
    >
      <div className="capability__wrap">
        <Col sm={5} className={"capability__img p-0"}>
          {data?.img && (
            <img
              className={"desktop"}
              data-speed={"clamp(1.2)"}
              src={data?.img}
              alt={"side"}
            />
          )}

          {data?.img && (
            <img className={"mobile"} src={data?.img} alt={"side"} />
          )}
        </Col>
        <Col
          sm={7}
          className={"capability__wrap__desc"}
          style={{ paddingRight: offset + "px" }}
        >
          {data?.title && (
            <Title
              color={White}
              margin={"0 0 20px 0"}
              text={data?.title}
              fontSize={"36"}
              fontWeight={"600"}
              lineHeight={"40"}
            />
          )}

          {data?.list && data?.list?.length > 0 && (
            <ul className="fade-up">
              {data?.list &&
                data?.list?.length > 0 &&
                data?.list?.map((e, index) => {
                  return (
                    <li>
                      <IconText
                        shortDesc={e?.desc}
                        imageSrc={e?.icon}
                        title={e?.title}
                      />
                    </li>
                  );
                })}
            </ul>
          )}
        </Col>
      </div>
    </StyledComponent>
  );
};

const StyledComponent = styled.section`
  background-color: #f4f4f4;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 50%;
    background: #fff;
  }

  .capability__wrap {
    display: flex;
    flex-wrap: wrap;

    position: relative;
    overflow: hidden;

    &__desc {
      background-color: #191919;
      padding-top: 125px;
      padding-bottom: 125px;
      padding-left: 100px;
      position: relative;
      z-index: 5;
      overflow: hidden;
      height: fit-content;

      .title {
        &:after {
          display: none;
        }
      }

      p {
        font-size: 16px;
        line-height: 20px;
        color: #b7b4b0;
      }

      ul {
        margin-top: 80px;
        padding-left: 80px;

        li {
          &:not(:nth-last-of-type(1)) {
            margin-bottom: 80px;
          }
        }
      }
    }

    .capability__img {
      position: relative;
      z-index: 5;

      img {
        width: 100%;
        object-fit: contain;
        //margin-top: 100px;
      }

      .mobile {
        display: none;
      }
    }
  }

  @media (max-width: 991px) {
    .capability__wrap {
      &__desc {
        min-width: 100%;
        padding-left: 50px;

        ul {
          padding-left: 0;

          li {
            flex-wrap: wrap;

            .wrap {
              min-width: 100%;
              //margin-top: 25px;
            }

            &:not(:nth-last-of-type(1)) {
              margin-bottom: 40px;
            }
          }
        }
      }

      .capability__img {
        min-width: 100%;
        img {
          margin-top: 0;
        }
      }
    }
  }

  @media (max-width: 767px) {
    .capability__wrap__desc {
      padding-left: 15px;
    }

    .desktop {
      display: none;
    }

    .mobile {
      display: block !important;
    }
  }
`;

export default MyComponent;
